// FeaturedPrograms.js
import React, { useState } from "react";
import { Container, Row, Col, Card, Button, Badge } from "react-bootstrap";
import { Calendar, Book, Layers, Heart } from "react-bootstrap-icons";

const programs = [
  {
    title: "Computer Science",
    years: "4 Years",
    credits: "120 Credits",
    season: "Fall & Spring",
    // type: "Bachelor's Degree",
    // degree: "Bachelor's",
    typeColor: "danger",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis.",
    image:
      "https://img.freepik.com/premium-photo/student-hand-holding-pencil-writing-exam-answer-sheet-classroom_67155-1402.jpg",
  },
  {
    title: "Business Administration",
    years: "3 Years",
    credits: "90 Credits",
    season: "Fall Only",
    // type: "Bachelor's Degree",
    // degree: "Bachelor's",
    typeColor: "danger",
    desc: "Nullam sed augue a turpis bibendum cursus. Suspendisse potenti. Praesent mi diam, feugiat a tincidunt at.",
    image: "https://img.freepik.com/free-photo/colorful-pencils_1203-2147.jpg",
  },
  {
    title: "Medical Sciences",
    years: "5 Years",
    credits: "150 Credits",
    season: "Fall Only",
    // type: "Bachelor's Degree",
    // degree: "Bachelor's",
    typeColor: "danger",
    desc: "Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae.",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQTqkwuaNS_ZTSpNxnSKmqLVGRFFy-jz1UkBA&s",
  },
  {
    title: "Environmental Studies",
    years: "2 Years",
    credits: "60 Credits",
    season: "Spring Only",
    // type: "Master's Degree",
    typeColor: "primary",
    desc: "Aenean imperdiet, erat vel consequat mollis, nunc risus aliquam nunc, eget condimentum eros dui sit amet.",
    image:
      "https://img.freepik.com/free-photo/children-celebrating-earth-day_53876-14042.jpg",
  },
];

const OurCourse = () => {
  const [activeTab, setActiveTab] = useState("All");

  // Filter logic
  const filteredPrograms =
    activeTab === "All"
      ? programs
      : programs.filter((p) => p.degree === activeTab);

  return (
    <Container className="py-2 pb-5">
      <div className="text-center mb-4">
        <h2 className="fw-bold">Our Courses</h2>
        <div
          style={{
            width: "60px",
            height: "3px",
            backgroundColor: "var(--main-color)",
            margin: "10px auto",
          }}
        ></div>
        <p className="text-muted">
          Necessitatibus eius consequatur ex aliquid fuga eum quidem sint
          consectetur velit
        </p>

        {/* Tabs */}
        <div className="d-flex justify-content-center gap-2 mt-3 flex-wrap">
        {["All", "Bachelor's", "Master's", "Certificates"].map((tab) => (
  <Button
    key={tab}
    className={`course-tab rounded-pill px-4 ${
      activeTab === tab ? "active-tab" : "inactive-tab"
    }`}
    onClick={() => setActiveTab(tab)}
  >
    {tab}
  </Button>
))}
        </div>
      </div>

      {/* Program Cards */}
     <Row className="g-4">
  {filteredPrograms.map((program, idx) => (
    <Col lg={6} key={idx}>
      <Card  className="course-card h-100 shadow-sm border-0 rounded-4 overflow-hidden position-relative">

        {/* Wishlist Icon */}
        <Button
          variant="light"
          className="position-absolute top-0 end-0 m-3 rounded-circle shadow-sm z-1"
        >
          <Heart />
        </Button>

        <Row className="g-0 h-100">

          {/* Image Section */}
          <Col md={5} className="d-flex">
            <div className="course-img w-100">
              <img
                src={program.image}
                alt={program.title}
                className="img-fluid"
              />
            </div>
          </Col>

          {/* Content Section */}
          <Col md={7} className="d-flex">
            <Card.Body className="d-flex flex-column">

              {/* Title + Badge */}
              <div className="d-flex justify-content-between align-items-start mb-2">
                <Card.Title className="fw-semibold course-title">
                  {program.title}
                </Card.Title>
                <Badge bg={program.typeColor}>
                  {program.degree}
                </Badge>
              </div>

              {/* Details */}
              <div className="d-flex flex-wrap mb-3 text-muted small gap-3">
                <span>
                  <Calendar className="me-1" /> {program.years}
                </span>
                <span>
                  <Book className="me-1" /> {program.credits}
                </span>
                <span>
                  <Layers className="me-1" /> {program.season}
                </span>
              </div>

              {/* Description */}
              <Card.Text className="text-muted flex-grow-1">
                {program.desc}
              </Card.Text>

              {/* Buttons */}
              <div className="d-flex justify-content-between align-items-center mt-auto">
                <a
                  href="#"
                  className="about-text fw-semibold text-decoration-none"
                >
                  Free Consulting →
                </a>
                <Button className="btn-grad border-0" size="sm">
                  Enroll Now
                </Button>
              </div>

            </Card.Body>
          </Col>

        </Row>
      </Card>
    </Col>
  ))}
</Row>
    </Container>
  );
};

export default OurCourse;
